<template>
  <div>
    <div class="Login base-height">
      <div class="mainBox">
        <router-link class="logo" to="/">
          <img src="@/assets/images/logo.jpeg" alt="novaLab" />
        </router-link>

        <div class="form login">
          <div class="snsLogin">
            <button
              type="button"
              class="btn full facebookBtn"
              @click="logInWithFacebook"
            >
              Facebook {{ $t("login") }}
            </button>
            <button class="btn full googleBtn" @click="googleLogin">
              Google {{ $t("login") }}
            </button>
          </div>
          <div class="private">
            <input type="checkbox" class="checkbox" name="privateLegalAgree" />
            <a @click="handleLegal">{{ $t("privatelegal") }}</a>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div v-if="visible" class="dim on">
        <privateLegal />
      </div>
    </transition>
  </div>
</template>
<script>
import { createFacebookLogin } from "@/api/index";
import privateLegal from "@/components/modal/privateLegal";
import { mapState } from "vuex";
import { format } from "@/mixins/format";
import axios from "axios";
import { eventBus } from "@/main";
import { baseUrl } from "@/config/env";
import { GOOGLE_CLIENT_ID, FACEBOOK_APP_ID } from "@/config/key";
export default {
  mixins: [format],
  components: { privateLegal },
  data() {
    return {
      baseUrl: baseUrl,
      visible: false,
      snsLogin: true,
      client_id: GOOGLE_CLIENT_ID,
      app_id: FACEBOOK_APP_ID,
    };
  },

  mounted() {
    this.initGoogle();
    this.initFacebook();
    eventBus.$on("closeModal", () => {
      this.closeModal();
    });
  },
  computed: {
    ...mapState(["isLogin"]),
  },
  methods: {
    initGoogle() {
      gapi.load("auth2", () => {
        gapi.auth2.init({
          client_id: this.client_id,
        });
      });
    },
    googleLogin() {
      const gauth = window.gapi.auth2.getAuthInstance();
      gauth.signIn().then((googleUser) => {
        let id_token = googleUser.getAuthResponse().id_token;
        axios({
          method: "POST",
          url: baseUrl + "/auth/google",
          data: {
            tokenId: id_token,
          },
        }).then((res) => {
          if (res.data.status === 200) {
            let data = {
              accesstoken: res.data.accesstoken,
              email: res.data.userInfo.email,
              username: res.data.userInfo.username,
            };
            this.$store.dispatch("LOGIN", data);
          } else {
            let message = res.data.message;
            alert(message);
          }
        });
      });
    },
    googleLoginFail(err) {
      window.console.log(err);
    },
    googleLoginSuccess(googleUser) {
      let id_token = googleUser.getAuthResponse().id_token;
      axios({
        method: "POST",
        url: baseUrl + "/auth/google",
        data: {
          tokenId: id_token,
        },
      }).then((res) => {
        if (res.data.status === 200) {
          let data = {
            accesstoken: res.data.accesstoken,
            email: res.data.userInfo.email,
            username: res.data.userInfo.username,
          };
          this.$store.dispatch("LOGIN", data);
        } else {
          let message = res.data.message;
          alert(message);
        }
      });
    },
    async logInWithFacebook() {
      await this.loadFacebookSDK(document, "script", "facebook-jssdk");
      await this.initFacebook();
      window.FB.login(
        (response) => {
          if (response.status === "connected") {
            let data = {
              userId: response.authResponse.userID,
              accessToken: response.authResponse.accessToken,
            };
            createFacebookLogin(data).then((res) => {
              if (res.data.status === 200) {
                let data = {
                  accesstoken: res.data.accesstoken,
                  username: res.data.userInfo.username,
                };
                this.$store.dispatch("LOGIN", data);
              } else {
                let message = res.data.message;
                alert(message);
              }
            });
          } else {
            alert("User cancelled login or did not fully authorize.");
          }
        },
        { scope: "public_profile,email" }
      );
      return false;
    },
    closeModal() {
      this.visible = false;
    },
    handleLegal() {
      this.visible = !this.visible;
    },
    async initFacebook() {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: this.app_id, //You will need to change this
          cookie: false, // This is important, it's not enabled by default
          version: "v9.0",
        });
      };
    },
    async loadFacebookSDK(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    },
    checkLoginState() {
      window.FB.getLoginStatus((response) => {}).then((res) => {
        this.statusChangeCallback(res);
      });
    },
    statusChangeCallback(response) {
      if (response.status === "connected") {
      } else {
      }
    },
    facebookLogout() {
      window.FB.getLoginStatus((response) => {
        window.FB.logout(async (res) => {});
      });
    },

    setElements(isLoggedIn) {
      if (isLoggedIn) {
      } else {
        window.console.log("Not auth");
      }
    },
    logout() {
      let accessToken = this.accessToken;
      window.FB.logout(accessToken).then((response) => {
        if (response) {
          this.setElements(true);
        }
      });
    },
  },
};
</script>
